module.exports = __webpack_public_path__ + "img/my.5adca325.png";